export const HOMI_STORAGE: string = '__lyceo-homi';
